<template>
  <v-bottom-sheet content-class="v-bottom-sheet" persistent v-model="isShown">
    <v-toolbar :color="bgColor" >

      <div class="header-block">
        <v-toolbar-title :style="{ color: defaultFontColor }">Webview</v-toolbar-title>

        <v-btn icon @click="isShown = false" >
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </div>
      
    </v-toolbar>
    <iframe :class="height" v-if="content" :src="content" frameborder="0"></iframe>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiClose } from '@mdi/js';

export default {
  name: 'WebviewModal',
  data() {
    return {
      isShown: false,
      content: null,
      height: 'tall',
      mdiClose
    };
  },
  computed: {
    ...mapGetters({
      isWebView: 'theme/isWebView',
    }),
    bgColor() {
      return this.$store.getters['theme/theme']?.common?.bgColor;
    },
    defaultFontColor() {
      return this.$store.getters['theme/theme'].common?.fontColor;
    },
  },
  created() {
    this.$root.$on('show:webview', (content) => {

      if (this.isWebView && content.parentType !== 'catalogue') {
        this.isShown = true;
        this.content = content.value;
        this.height = content.height || 'tall';
      } else {
        window.open(content.value, '_blank');
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.compact {
  min-height: 40vh;
}
.tall {
  min-height: 60vh;
}
.full {
  min-height: 100vh;
}
.header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
